import { cn } from '@/lib/utils';
import { Checkbox } from '@/components/ui/Checkbox';

type GapSize = 'none' | '4' | '8' | '12' | '16' | '20' | '24' | '32' | '40' | '48' | '64' | '72';

type Props = {
  label?: string;
  isChecked: boolean;
  id: string;
  disabled?: boolean;
  comment?: string;
  backgroundWhite?: boolean;
  onChange?: (checked?: boolean) => void;
  gapSize?: GapSize;
};

const gapMap: Record<GapSize, string> = {
  none: 'gap-0',
  '4': 'gap-1',
  '8': 'gap-2',
  '12': 'gap-3',
  '16': 'gap-4',
  '20': 'gap-5',
  '24': 'gap-6',
  '32': 'gap-8',
  '40': 'gap-10',
  '48': 'gap-12',
  '64': 'gap-16',
  '72': 'gap-[4.5rem]',
};

export const CheckBox = ({
  label,
  isChecked = false,
  id,
  disabled = false,
  comment = '',
  backgroundWhite = false,
  onChange = () => {},
  gapSize = '8',
}: Props) => {
  return (
    <label
      htmlFor={id}
      className={cn(
        'flex items-center cursor-pointer',
        gapMap[gapSize],
        disabled && 'opacity-50 cursor-not-allowed',
        comment && 'items-start',
        backgroundWhite && 'bg-background',
      )}
    >
      <Checkbox
        id={id}
        checked={isChecked}
        disabled={disabled}
        onCheckedChange={(checked) => onChange?.(checked as boolean)}
        className={cn(comment && 'mt-0.5')}
      />
      {(label || comment) && (
        <span className='flex flex-col gap-0.5'>
          {label && <span className='text-sm text-foreground select-none'>{label}</span>}
          {comment && <span className='text-xs text-muted-foreground select-none'>{comment}</span>}
        </span>
      )}
    </label>
  );
};

export default CheckBox;
